
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta } from "/vercel/path0/pages/account.vue?macro=true";
import { default as releasesG6QYav1TY3JQmYLaBK_45NFICN4iHAgTS_45A1p458VT0EQMeta } from "/vercel/path0/pages/releases.vue?macro=true";
import { default as statisticsxkd3GJsJiLBaQTtdknWdanrz1D_NNABVY_PykFQ6blkMeta } from "/vercel/path0/pages/statistics.vue?macro=true";
import { default as styleguideUJgsG_J4d_j7Mn3lh3sFFGfvxhr7YPDBMRUzlLBIL5YMeta } from "/vercel/path0/pages/styleguide.vue?macro=true";
import { default as login_45local3EnoyhyTampOk2QJS4NNJ406xT4DjIM8lQItmAx0C7oMeta } from "/vercel/path0/pages/login-local.vue?macro=true";
import { default as _91uid_93ajkL8xpPvJDsCj9xH2LfS0hbZ2SYdeDFStL7PgDUjqEMeta } from "/vercel/path0/pages/matches/[uid].vue?macro=true";
import { default as indexQThifBc3_gU3INfwfI_456Dx5xAhY2zHq5hfTJAeOfuRkMeta } from "/vercel/path0/pages/matches/index.vue?macro=true";
import { default as _91uid_934eTg4low5FS7Xlhm2_7UZML2dzfOq55HXPqy1O_8ahEMeta } from "/vercel/path0/pages/profiles/[uid].vue?macro=true";
import { default as index4Tw1ZTl_45a5lQVh6M4fRmd1Q93tpVeSlZSnlNabRZjYQMeta } from "/vercel/path0/pages/profiles/index.vue?macro=true";
import { default as utilsa_45QPRWx_45y6uxm_45fK_mwAKO3pClY_MgQwO6BynYsgXRcMeta } from "/vercel/path0/pages/suggestions/utils.ts?macro=true";
import { default as searchpoc_45jobfileoWo5asVkC0M2Fmjg_tNMTR2mdWH9Pk_458qbvnVnT4dg0Meta } from "/vercel/path0/pages/searchpoc-jobfile.vue?macro=true";
import { default as indexijzHWmS8Tk00UkrSACXQZGmk1_45cWfhPS_454r262BLRs8Meta } from "/vercel/path0/pages/suggestions/index.vue?macro=true";
import { default as _91token_hash_932_45CCDWAtpdr3KFDLUbnKuc3b41oTLXJCkNJFCfG1wzkMeta } from "/vercel/path0/pages/sign_in/[token_hash].vue?macro=true";
import { default as _91step_93ezzCeTIKaQsYNwHZx6AkugWgWX_45nYbj2YirIuKGl6uwMeta } from "/vercel/path0/pages/profiles/create/[step].vue?macro=true";
import { default as suggestion_45_91id_93JCx73B0DrtFgrOmEb_45AYQVIGR1c70YAKdM2nqnFdxRcMeta } from "/vercel/path0/pages/suggestions/suggestion-[id].vue?macro=true";
import { default as _91access_token_937FEqtl_45I4K9JOB_45YxYyKUcM80QZnWG1aA7ngvsw1FK4Meta } from "/vercel/path0/pages/company/public/[access_token].vue?macro=true";
import { default as _91access_token_93cZFTlrx3vrI5UQHj6vGDv6Aw6r2Ve52PozV8ODGRANcMeta } from "/vercel/path0/pages/matches/public/[access_token].vue?macro=true";
import { default as _91uid_93ec1cNVurlhUJ_450iDJHyL_45OO1HVM4kouoCX4DJ3VdrPEMeta } from "/vercel/path0/pages/profiles/create/success/[uid].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {}), ...{"middleware":"onboarding"} },
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/vercel/path0/pages/account.vue")
  },
  {
    name: "releases",
    path: "/releases",
    meta: releasesG6QYav1TY3JQmYLaBK_45NFICN4iHAgTS_45A1p458VT0EQMeta || {},
    component: () => import("/vercel/path0/pages/releases.vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: { ...(statisticsxkd3GJsJiLBaQTtdknWdanrz1D_NNABVY_PykFQ6blkMeta || {}), ...{"middleware":"assert-internal-user"} },
    component: () => import("/vercel/path0/pages/statistics.vue")
  },
  {
    name: "styleguide",
    path: "/styleguide",
    meta: { ...(styleguideUJgsG_J4d_j7Mn3lh3sFFGfvxhr7YPDBMRUzlLBIL5YMeta || {}), ...{"middleware":"assert-internal-user"} },
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "login-local",
    path: "/login-local",
    meta: login_45local3EnoyhyTampOk2QJS4NNJ406xT4DjIM8lQItmAx0C7oMeta || {},
    component: () => import("/vercel/path0/pages/login-local.vue")
  },
  {
    name: "matches-uid",
    path: "/matches/:uid()",
    meta: _91uid_93ajkL8xpPvJDsCj9xH2LfS0hbZ2SYdeDFStL7PgDUjqEMeta || {},
    component: () => import("/vercel/path0/pages/matches/[uid].vue")
  },
  {
    name: "matches",
    path: "/matches",
    component: () => import("/vercel/path0/pages/matches/index.vue")
  },
  {
    name: "profiles-uid",
    path: "/profiles/:uid()",
    meta: _91uid_934eTg4low5FS7Xlhm2_7UZML2dzfOq55HXPqy1O_8ahEMeta || {},
    component: () => import("/vercel/path0/pages/profiles/[uid].vue")
  },
  {
    name: "profiles",
    path: "/profiles",
    component: () => import("/vercel/path0/pages/profiles/index.vue")
  },
  {
    name: "suggestions-utils",
    path: "/suggestions/utils",
    component: () => import("/vercel/path0/pages/suggestions/utils.ts")
  },
  {
    name: "searchpoc-jobfile",
    path: "/searchpoc-jobfile",
    meta: { ...(searchpoc_45jobfileoWo5asVkC0M2Fmjg_tNMTR2mdWH9Pk_458qbvnVnT4dg0Meta || {}), ...{"middleware":"assert-internal-user"} },
    component: () => import("/vercel/path0/pages/searchpoc-jobfile.vue")
  },
  {
    name: "suggestions",
    path: "/suggestions",
    component: () => import("/vercel/path0/pages/suggestions/index.vue")
  },
  {
    name: "sign_in-token_hash",
    path: "/sign_in/:token_hash()",
    meta: _91token_hash_932_45CCDWAtpdr3KFDLUbnKuc3b41oTLXJCkNJFCfG1wzkMeta || {},
    component: () => import("/vercel/path0/pages/sign_in/[token_hash].vue")
  },
  {
    name: "profiles-create-step",
    path: "/profiles/create/:step()",
    meta: _91step_93ezzCeTIKaQsYNwHZx6AkugWgWX_45nYbj2YirIuKGl6uwMeta || {},
    component: () => import("/vercel/path0/pages/profiles/create/[step].vue")
  },
  {
    name: "suggestions-suggestion-id",
    path: "/suggestions/suggestion-:id()",
    component: () => import("/vercel/path0/pages/suggestions/suggestion-[id].vue")
  },
  {
    name: "company-public-access_token",
    path: "/company/public/:access_token()",
    meta: _91access_token_937FEqtl_45I4K9JOB_45YxYyKUcM80QZnWG1aA7ngvsw1FK4Meta || {},
    component: () => import("/vercel/path0/pages/company/public/[access_token].vue")
  },
  {
    name: "matches-public-access_token",
    path: "/matches/public/:access_token()",
    meta: _91access_token_93cZFTlrx3vrI5UQHj6vGDv6Aw6r2Ve52PozV8ODGRANcMeta || {},
    component: () => import("/vercel/path0/pages/matches/public/[access_token].vue")
  },
  {
    name: "profiles-create-success-uid",
    path: "/profiles/create/success/:uid()",
    meta: _91uid_93ec1cNVurlhUJ_450iDJHyL_45OO1HVM4kouoCX4DJ3VdrPEMeta || {},
    component: () => import("/vercel/path0/pages/profiles/create/success/[uid].vue")
  }
]